import { useDispatch } from 'react-redux';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';

const useChangeOrderShipper = () => {
  const dispatch = useDispatch();

  const changeOrderShipper = async (orderRef, shipper) => {
    if (!orderRef || !shipper) {
      dispatch(
        setSnackBar({
          open: true,
          message: 'Reference commande ou transporteur manquant',
          color: 'error',
        })
      );
      return null;
    }

    try {
      let responseData = null;
      await AxiosConfig.create('post', `/orders/${orderRef}/changeShipper`)
        .call({ shipper })
        .exit((res) => (responseData = res?.data));

      dispatch(
        setSnackBar({
          open: true,
          message:
            responseData?.message ||
            `Transporteur ${shipper} applique sur ${orderRef}`,
          color: 'success',
        })
      );
      return responseData;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.errorMessage ||
        'Erreur lors du changement de transporteur';
      dispatch(
        setSnackBar({
          open: true,
          message: errorMessage,
          color: 'error',
        })
      );
      return null;
    }
  };

  return { changeOrderShipper };
};

export default useChangeOrderShipper;
